<template>
    <v-app id="myApp">
        <AppHeader v-if="isShowed" />
        <AppProgress v-if="isShowed" />
        <AppNotification v-if="isShowed" />
        <v-main>
            <router-view :key="$route.fullPath"></router-view>
        </v-main>
        <AppFooter v-if="isShowed" />
        <UpdateChecker v-if="isShowed" />
        <Loader />
    </v-app>
</template>

<script>
import AppHeader from './components/layout/AppHeader';
import AppProgress from './components/layout/AppProgress';
import AppNotification from './components/layout/AppNotification';
import AppFooter from './components/layout/AppFooter';
import UpdateChecker from './components/ui/UpdateChecker';
import { mapActions, mapGetters } from 'vuex';
import Loader from '@/components/ui/Loader.vue';

export default {
    name: 'App',
    components: { Loader, AppHeader, AppProgress, AppFooter, AppNotification, UpdateChecker },
    computed: {
        ...mapGetters('auth', ['loggedIn']),
        isShowed() {
            try {
                return !(window.self !== window.top);
            } catch (e) {
                return true;
            }
        }
    },
    watch: {
        loggedIn(loggedIn) {
            if (loggedIn) this.init();
        }
    },
    methods: {
        ...mapActions('users', ['getRoleList', 'getUserInfo', 'setUserRoles']),
        ...mapActions('ahsRequests', ['getRequestTypes']),

        async init() {
            await this.getUserInfo();
            await this.getRoleList();
            this.setUserRoles();
            await this.getRequestTypes();
        }
    },
    async mounted() {
        this.$watch(
            '$i18n.locale',
            (newLocale, oldLocale) => {
                if (newLocale === oldLocale) {
                    return;
                }
                document.title = this.$t('Модуль по работе с актами');
            },
            { immediate: true }
        );

        if (this.loggedIn) await this.init();
    }
};
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

$primaryColor: #363e59;
$hoverColor: #6b7bb2;
.v-btn:not(.v-btn--icon, .v-btn--outlined) {
    /* 500: Roboto Medium */
    font-weight: 500;

    &:hover,
    &:active {
        background-color: $hoverColor;
    }
}

.v-btn.v-btn--icon:not(.red--text) {
    &:hover,
    &:active {
        i {
            color: $hoverColor;
        }
    }
}
.v-btn.v-btn.v-btn--icon {
    &:hover,
    &:active {
        i.mdi-filter-remove {
            color: #ac342f !important;
        }
    }
}

//.v-application .v-btn {
//    &--outlined {
//        &:hover,
//        &:active {
//            background-color: transparent;
//            color: $hoverColor !important;
//            border-color: $hoverColor !important;
//        }
//    }
//}

// Global style for decimal values in tables
.number-cell {
    text-align: right !important;
}
// Global style for error values in tables
.error-cell {
    color: #d63730;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
